import cx from "classnames";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { Portal } from "react-portal";
import { CSSTransition } from "react-transition-group";

import { CartContents } from "@/components/Cart/CartContents";
import { DialogBgClose } from "@/components/elements/DialogBgClose";
import { CART_IS_OPEN_QUERY_PARAM } from "@/constants";
import useGetQueryValue from "@/hooks/useGetQueryValue";
import useGlobalState from "@/hooks/useGlobalState";
import useRemoveScrollBar from "@/hooks/useRemoveScrollBar";

import styles from "./styles.module.css";

export const Cart = () => {
  const {
    cartIsOpen,
    toggleCartIsOpen,
    disableCartAutoClose,
    setDisableCartAutoClose,
  } = useGlobalState();
  const { removeScrollBar, reinstateScrollBar } = useRemoveScrollBar();
  const shouldOpenCart = useGetQueryValue(CART_IS_OPEN_QUERY_PARAM) === "true";
  // Close cart when changing routes
  const router = useRouter();
  useEffect(() => {
    const handleRouteChange = () => {
      if (disableCartAutoClose) {
        setDisableCartAutoClose(false);
        return;
      }
      toggleCartIsOpen(false);
    };
    router.events.on("routeChangeStart", handleRouteChange);
    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, []);

  useEffect(() => {
    if (shouldOpenCart) toggleCartIsOpen(true);
  }, [shouldOpenCart]);

  useEffect(() => {
    cartIsOpen ? removeScrollBar() : reinstateScrollBar();
  }, [cartIsOpen]);

  return (
    <Portal>
      <CSSTransition
        in={cartIsOpen}
        unmountOnExit
        classNames={{
          appear: styles.appear,
          appearActive: styles.appearActive,
          appearDone: styles.appearDone,
          enter: styles.enter,
          enterActive: styles.enterActive,
          enterDone: styles.enterDone,
          exit: styles.exit,
          exitActive: styles.exitActive,
          exitDone: styles.exitDone,
        }}
        addEndListener={(node, done) => {
          const modalInner = node.firstChild;
          modalInner.addEventListener("transitionend", done, false);
        }}
      >
        <div className={cx(styles.dialog)}>
          <div className={styles.dialogInner} id="cartDialogInner">
            <CartContents />
          </div>
          <DialogBgClose
            onClick={() => {
              toggleCartIsOpen(false);
            }}
            label="close_cart_CTA"
            className={styles.dialogBg}
          />
        </div>
      </CSSTransition>
    </Portal>
  );
};
